export default {
	emailRegex: /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/,
	phoneRegex: /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/,
	numberRegex: /^[0-9]*$/,
	exceptNumberRegex: /^([^0-9]*)$/,
	spaceRegex: /^\s+$/g,
	specialCharRegex: /^[a-zA-Z\d\-_.,\s]+$/,
	urlRegex: /^https?:\/\/+[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
	stripePubKeyBeta: 'pk_test_On7F5lbpijoNlLvtVGSQsFnH',
	stripePubKeyLive: 'pk_live_IdHTcBcTnKOG0KMhWIdDQelw',
	paypalSecKeyBeta: 'Ae6rKJN84Lc4xUebNbNsKAFppIpQqVZS-BIFfItfzgL3668bHqgj7j2TQIL0KBT4u8w3n0370HKGgYE7',
	paypalSecKeyLive: 'Ae6rKJN84Lc4xUebNbNsKAFppIpQqVZS-BIFfItfzgL3668bHqgj7j2TQIL0KBT4u8w3n0370HKGgYE7',
	// New: Disallowed email domains
	disallowedDomains: [
		// Google
		"gmail.com",

		// Yahoo group
		"yahoo.com",
		"ymail.com",
		"rocketmail.com",

		// Microsoft group
		"hotmail.com",
		"outlook.com",
		"live.com",
		"msn.com",

		// Apple
		"icloud.com",
		"me.com",
		"mac.com",

		// Secure/personal free email providers
		"protonmail.com",
		"pm.me",
		"tutanota.com",
		"fastmail.com",
		"gmx.com",
		"zoho.com",
		"aol.com",
		"mail.com",
		"yandex.com",
		"yandex.ru",

		// Disposable / temporary email providers
		"mailinator.com",
		"tempmail.com",
		"guerrillamail.com",
		"10minutemail.com",
		"getnada.com",
		"trashmail.com",
		"fakeinbox.com",
		"maildrop.cc",
		"dispostable.com",
		"sharklasers.com",
		"yopmail.com",
		"throwawaymail.com",
		"moakt.com",

		// Common QA/test domains
		"example.com",
		"test.com",
		"testing.com",
		"email.com",

		// 🔻 Regional Free Providers (Asia, Europe, etc.)
		"qq.com",             // China - Tencent Mail
		"163.com",            // China - NetEase Mail
		"126.com",            // China - NetEase Mail
		"sina.com",           // China - Sina Mail
		"naver.com",          // Korea - Naver
		"daum.net",           // Korea - Daum
		"rediffmail.com",     // India - Rediff
		"mail.ru",            // Russia - Mail.ru
		"bk.ru",              // Russia - Mail.ru
		"list.ru",            // Russia - Mail.ru
		"inbox.ru",           // Russia - Mail.ru
		"web.de",             // Germany
		"freenet.de",         // Germany
		"libero.it",          // Italy
		"seznam.cz",          // Czech
		"centrum.cz",         // Czech
		"wp.pl",              // Poland
		"onet.pl",            // Poland
		"abv.bg",             // Bulgaria
		"mail.bg"             // Bulgaria
	],
}
